import { LoadingButton } from "@mui/lab";
import { Paper, Typography, useTheme } from "@mui/material";

import Doutor from "../../../../../img/doutor.png";
import Estetica from "../../../../../img/estetica.png";

export function TrainingButtons({
  handleStudioEad,
  loadingStudioEad,
  userCourses,
  verifyBU,
  loadingGetBU,
  errorPartnerBU,
}) {
  const theme = useTheme();
  const { isMedicalBU, isBeautyBU } = verifyBU;

  if (errorPartnerBU) {
    return (
      <Paper
        sx={{
          borderRadius: 1,
          textTransform: "capitalize",
          width: { xs: "100%", md: "370px" },
          height: "auto",
          minHeight: "120px",
          padding: "16px",
          fontWeight: "600",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "0.875rem",
        }}
      >
        <Typography
          variant="body1"
          color={theme.palette.error.main}
          fontWeight={500}
          textAlign="center"
        >
          Erro Ao Carregar Informações Do Parceiro BU.
        </Typography>
      </Paper>
    );
  }
  return (
    <>
      {!loadingGetBU && isMedicalBU && (
        <LoadingButton
          onClick={() => handleStudioEad("med")}
          variant="outlined"
          loading={loadingStudioEad === "med"}
          sx={{
            borderRadius: 1,
            backgroundColor: "#ffff",
            textTransform: "capitalize",
            width: { xs: "100%", md: "370px" },
            height: "63px",
            fontWeight: "600",
          }}
          size="large"
          endIcon={
            <img
              src={Doutor}
              alt="icone de doutor"
              style={{
                position: "absolute",
                right: "8px",
                bottom: "18.5px",
              }}
            />
          }
          disabled={!userCourses?.medsystemsAcademy}
        >
          Médicos
        </LoadingButton>
      )}

      {!loadingGetBU && isBeautyBU && (
        <LoadingButton
          onClick={() => handleStudioEad("beauty")}
          variant="outlined"
          loading={loadingStudioEad === "beauty"}
          sx={{
            borderRadius: 1,
            backgroundColor: "#ffff",
            textTransform: "capitalize",
            width: { xs: "100%", md: "370px" },
            height: "63px",
            fontWeight: "600",
            ml: { xs: 0, md: 2 },
          }}
          size="large"
          endIcon={
            <img
              src={Estetica}
              alt="icone de estetica"
              style={{
                position: "absolute",
                right: "8px",
                bottom: "18.5px",
              }}
            />
          }
          disabled={!userCourses?.beautyAcademy}
        >
          Especialista
        </LoadingButton>
      )}
    </>
  );
}
